import type { FilterDTO, FilterItemDTO } from "../../search";
export abstract class BodyTypeTransformer {
  private static readonly mappedValues: Record<string, string> = {
    hatchback: "Hatch",
    "utilitário esportivo": "SUV",
    "van/utilitário": "Van/Utilitário/Furgão",
  };

  /**
   * Transforms a given `FilterDTO` for body types by mapping known body type labels
   * to their display names and sorting the items by label.
   *
   * @param {FilterDTO} filter - The filter object to transform.
   * @returns {FilterDTO} - The transformed filter object with mapped and sorted items.
   */
  static transform(filter: FilterDTO): FilterDTO {
    if (!filter || filter.name !== "BodyType") return filter;

    const transformedItems: FilterItemDTO[] = filter.items
      .map((item) => {
        const value = item.label?.toLocaleLowerCase();
        return {
          ...item,
          label: BodyTypeTransformer.mappedValues[value ?? ""] ?? item.label,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));

    return {
      ...filter,
      items: transformedItems,
    };
  }

  /**
   * Transforms an array of body type strings from a URL by mapping known body type labels
   * to their display names.
   *
   * @param {string[]} bodyTypes - The array of body type strings to transform.
   * @returns {Array<{ value: string, label: string }>} - An array of objects containing the original value and the mapped label.
   */
  static transformFromUrl(
    bodyTypes: string[]
  ): Array<{ value: string; label: string }> {
    return bodyTypes.map((bodyType) => {
      const value = bodyType.toLocaleLowerCase();
      return {
        value: bodyType,
        label: BodyTypeTransformer.mappedValues[value] ?? bodyType,
      };
    });
  }
}
